












import Vue from 'vue'

import WidgetBoard from 'widget-board/WidgetBoard.vue'

export default Vue.extend({
  components: {
    WidgetBoard
  },
  computed: {
    darkMode() {
      return this.$store.state.app.darkMode
    },
    accessAllowedDashboard() {
      return this.$store.state.user.access.dashboard
    }
  }
})
